import React, { Component } from "react";
import CloseIcon from "@material-ui/icons/Close";
import { auth } from "../AuthService";
import constants from "../Constants/constants";
import "./LoginModal.css";

export default class LoginModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      error: null,
      mode: "login", // "login" or "signup"
      email: "",
      userName: "",
      location: "",
    };
  }

  componentDidUpdate(prevProps) {
    if (this.props.isOpen && !prevProps.isOpen) {
      this.setState({ mode: "login", error: null, email: "", userName: "", location: "" });
    }
  }

  handleEmailLogin = async (e) => {
    e.preventDefault();
    const { email } = this.state;
    if (!email.trim()) {
      this.setState({ error: "Please enter your email." });
      return;
    }
    this.setState({ loading: true, error: null });
    try {
      const res = await fetch(`${constants.DOMAIN}api/v1/users/login`, {
        method: "POST",
        mode: "cors",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email: email.trim(), password: "x" }),
      });
      if (!res.ok) {
        const status = res.status;
        if (status === 401) {
          throw new Error("No account found with that email.");
        }
        throw new Error("Login failed. Please try again.");
      }
      const userData = await res.json();
      auth.setToken(userData.token);
      this.setState({ loading: false });
      if (this.props.onLoginSuccess) this.props.onLoginSuccess(userData);
    } catch (err) {
      this.setState({ loading: false, error: err.message || "Login failed. Please try again." });
    }
  };

  handleEmailSignup = async (e) => {
    e.preventDefault();
    const { email, userName, location } = this.state;
    if (!email.trim() || !userName.trim() || !location.trim()) {
      this.setState({ error: "All fields are required." });
      return;
    }
    this.setState({ loading: true, error: null });
    try {
      const res = await fetch(`${constants.DOMAIN}api/v1/users/signup`, {
        method: "POST",
        mode: "cors",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          email: email.trim(),
          userName: userName.trim(),
          location: location.trim(),
          name: userName.trim(),
          password: "placeholder",
        }),
      });
      if (!res.ok) throw new Error("Signup failed");
      const userData = await res.json();
      auth.setToken(userData.token);
      this.setState({ loading: false });
      if (this.props.onLoginSuccess) this.props.onLoginSuccess(userData);
    } catch (err) {
      this.setState({ loading: false, error: "Signup failed. Email may already be in use." });
    }
  };

  render() {
    const { isOpen, onClose } = this.props;
    const { loading, error, mode, email, userName, location } = this.state;

    if (!isOpen) return null;

    const darkMode = this.props.darkMode === undefined ? true : this.props.darkMode;

    return (
      <div className="login-modal-overlay" onClick={onClose}>
        <div className={`login-modal ${darkMode ? "login-dark" : "login-light"}`} onClick={(e) => e.stopPropagation()}>
          <button className="login-modal-close" onClick={onClose} aria-label="Close">
            <CloseIcon />
          </button>

          <h2 className="login-modal-title">
            {mode === "login" ? (this.props.title || "Sign in to save your deck") : "Create an account"}
          </h2>
          <p className="login-modal-subtitle">
            {this.props.subtitle || "Your deck will be saved to your account and visible on the Community Decks page."}
          </p>

          {error && <div className="login-modal-error">{error}</div>}

          {mode === "login" ? (
            <form className="login-modal-form" onSubmit={this.handleEmailLogin}>
              <input
                className="login-modal-input"
                type="email"
                placeholder="Email address"
                value={email}
                onChange={(e) => this.setState({ email: e.target.value })}
                disabled={loading}
                autoComplete="email"
              />
              <button className="login-modal-submit" type="submit" disabled={loading || !email.trim()}>
                {loading ? "Signing in..." : "Sign In"}
              </button>
              <p className="login-modal-switch">
                Don't have an account?{" "}
                <button
                  type="button"
                  className="login-modal-switch-btn"
                  onClick={() => this.setState({ mode: "signup", error: null })}
                >
                  Sign up
                </button>
              </p>
            </form>
          ) : (
            <form className="login-modal-form" onSubmit={this.handleEmailSignup}>
              <input
                className="login-modal-input"
                type="text"
                placeholder="Username"
                value={userName}
                onChange={(e) => this.setState({ userName: e.target.value })}
                disabled={loading}
                autoComplete="username"
              />
              <input
                className="login-modal-input"
                type="email"
                placeholder="Email address"
                value={email}
                onChange={(e) => this.setState({ email: e.target.value })}
                disabled={loading}
                autoComplete="email"
              />
              <input
                className="login-modal-input"
                type="text"
                placeholder="Location (e.g. New York, USA)"
                value={location}
                onChange={(e) => this.setState({ location: e.target.value })}
                disabled={loading}
              />
              <button
                className="login-modal-submit"
                type="submit"
                disabled={loading || !email.trim() || !userName.trim() || !location.trim()}
              >
                {loading ? "Creating account..." : "Create Account"}
              </button>
              <p className="login-modal-switch">
                Already have an account?{" "}
                <button
                  type="button"
                  className="login-modal-switch-btn"
                  onClick={() => this.setState({ mode: "login", error: null })}
                >
                  Sign in
                </button>
              </p>
            </form>
          )}
        </div>
      </div>
    );
  }
}
